export const CREDIT_UNION = {
    INFO: {
      NAME: 'Credit Union West',
      PHONE: '480-660-8632',
      CONTACT: '14806608632',
      EMAIL: 'ask@autorefi.cuwest.org',
    },
    LINKS: {
      WEBSITE: 'https://cuwest.org/',
      BRANCH_LOCATOR: 'https://www.cuwest.org/resources/contact-us/locations-and-hours',
      APPOINTMENT: 'https://cuwest.coconutcalendar.com/location?_gl=1*znidma*_gcl_au*MTgwNTI3NzczNy4xNzU2MTM1NjM0*_ga*ODE3NjgyNDM0LjE3NDA1MTEzMzI.*_ga_PK1YXVPRJ0*czE3NTc3MDc2NDQkbzkkZzAkdDE3NTc3MDc2NDQkajYwJGwwJGgw',
      PRIVACY_POLICY: 'https://www.cuwest.org/privacy-policy'
    },
    SUPPORT: {
      SPANISH_PHONE: '800-914-7536',
    },
    ABOUT: {
      TEXT: 'Credit Union West was founded in 1951 as Luke Federal Credit Union on Luke Air Force Base, dedicated to serving military members and their families. While we proudly continue our strong ties to the military, our mission has grown. Today, we serve individuals who live, work, or worship in Apache, Cochise, Coconino, Gila, Maricopa, Mohave, Navajo, Pima, Pinal, Yavapai, or Yuma County. As a not-for-profit credit union, our focus is always on people over profits—returning earnings to our members through better rates, lower fees, and community support.',
    },
  };
  
  export const FAQ_LIST = [
    {
      id: 'faq1',
      question: 'Is there a fee to apply?',
      answer: 'There is no fee to apply.',
    },
    {
      id: 'faq2',
      question: 'Once I am pre-qualified, when does my offer expire?',
      answer: 'Your offer expires 6 weeks after you have been pre-qualified. You may use your offer up to the expiration date. If your offer expires before you are ready to refinance your vehicle, you are still welcome to apply, rates and payments are subject to change due to market conditions.',
    },
    {
      id: 'faq3',
      question: "What if I don't have excellent credit?",
      answer: 'All credit scores are welcome! In fact, those with less-than-perfect credit often find more savings. Apply now to see what your savings might be every month. If you received an offer of credit letter with a promo code, you were already pre-qualified at that time and meet our initial credit criteria.',
    },
    {
      id: 'faq4',
      question: 'Do I have to extend the term of my current loan?',
      answer: 'You are not required to extend your loan beyond your current term. In some cases, this may be required to meet lending requirements or if you are trying to maximize your monthly savings.',
    },
    {
      id: 'faq5',
      question: 'Is my personal information secure?',
      answer: {
        type: 'link',
        text: 'Credit Union West and our marketing partner take the security of your personal information seriously. Please review our ',
        linkText: 'privacy policy',
        href: 'https://www.cuwest.org/privacy-policy',
        postText: ' on our corporate website for details.',
      },
    },
    {
      id: 'faq6',
      question: 'What does pre-qualification mean?',
      answer: 'Pre-qualification refers to being pre-approved based on the credit information provided to our financial institution by the credit bureaus. You were selected based on your credit score falling within an acceptable range. Other factors need to be reviewed before approval, like the vehicle information and your current employment information.',
    },
    {
      id: 'faq7',
      question: 'How do I benefit by refinancing my auto loan?',
      answer: 'In most cases, if you financed through a dealership, you would probably save a significant amount by refinancing. Or if your credit score increased since purchasing the vehicle, you may qualify now for a lower rate.',
    },
    {
      id: 'faq8',
      question: 'What documents will I need to provide the lender?',
      answer: {
        type: 'list',
        text: 'In general, these documents will be required:',
        items: [
          "Driver’s License",
          "Registration",
          "Proof of Insurance",
          "Proof of Income",
          "Title: if you are in a state where you are responsible for holding the vehicle title, you will need to provide it for the title to be perfected for the new lender",
          'Other documentation may be required.'
        ],
      },
    },
  ];
